/* GENERATED BY `js-common lang`, DO NOT EDIT MANUALLY */
export default {
  getN: (n) => n !== 1,
  messages: {
    _: {
      'Choose date': 'Välj datum',
      'Previous year': 'Föregående år',
      'Previous month': 'Föregående månad',
      'Next month': 'Nästa månad',
      'Next year': 'Nästa år',
      'Close date picker': 'Stäng datumväljare',
      'selected date is {{date}}': 'valt datum är {{date}}',
      'You can navigate dates with the arrow keys':
        'Du kan navigera datum med piltangenterna',
    },
  },
};
